
export default {
  name: 'VisionButton',
  props: {
    backgroundColor: {
      type: String,
      default: 'black'
    },
    href: {
      type: String,
      default: ''
    },
    subTitle: {
      type: String,
      default: ''
    },
    title: {
      type: String,
      default: ''
    }
  }
}
